import React from "react";
import useUnileverLogo from "../../hooks/useUnileverLogo";
import { Organization } from "schema-dts";
import JSONLDTag from "./JSONLDTag";
import { getSrc, ImageDataLike } from "gatsby-plugin-image";

export default function JSONLDTagOrganization() {
  const logo = useUnileverLogo();
  return (
    <JSONLDTag<Organization>
      json={{
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": "https://www.unilever.com/#organization",
        name: "Unilever",
        url: "https://www.unilever.com",
        logo: getSrc(logo as ImageDataLike),
        address: {
          "@type": "PostalAddress",
          addressLocality: "London",
          addressCountry: "United Kingdom",
          postalCode: "EC4Y 0DY",
          streetAddress: "Unilever House, 100 Victoria Embankment",
        },
        contactPoint: [
          {
            "@type": "ContactPoint",
            telephone: "+31 (0) 10 217 4000",
            contactType: "Media Relations",
          },
          {
            "@type": "ContactPoint",
            email: "Press-Office.London@Unilever.com",
            contactType: "Press Office",
          },
          {
            "@type": "ContactPoint",
            email: "mediarelations.rotterdam@Unilever.com",
            contactType: "Media Relations",
          },
        ],
      }}
    />
  );
}
